import { useTranslate } from '@va/localization';
import classNames from 'classnames';
import { fontWeights, paragraphSizes, ParagraphWithTooltip } from '../typography';

type EngagementBarProps = {
  colors?: {
    high?: string;
    medium?: string;
    low?: string;
  };
  text?: {
    high?: string;
    medium?: string;
    low?: string;
  };
  className?: string;
};

export const EngagementBar = ({ colors, text, className }: EngagementBarProps) => {
  const translate = useTranslate();

  const highColor = colors?.high || window.POSITIVE_COLOR;
  const mediumColor = colors?.medium || window.NEUTRAL_COLOR;
  const lowColor = colors?.low || window.NEGATIVE_COLOR;

  return (
    <div className={classNames('h-12 overflow-hidden rounded-13.5 bg-white-snow flex flex-col', className)}>
      <div className='w-full grow flex items-center justify-evenly gap-4 px-3'>
        <LegendItem text={text?.high || translate('funnels.engagement.high')} color={highColor} />
        <LegendItem text={text?.medium || translate('funnels.engagement.medium')} color={mediumColor} />
        <LegendItem text={text?.low || translate('funnels.engagement.low')} color={lowColor} />
      </div>
      <div
        className='h-[0.2812rem]'
        style={{
          background: `linear-gradient(90deg, ${highColor} 0%, ${mediumColor} 50%,  ${lowColor} 100%)`,
        }}
      ></div>
    </div>
  );
};

const LegendItem = ({ text, color }: { text: string; color: string }) => {
  return (
    <div className='flex items-center gap-2 flex-1 overflow-hidden justify-center'>
      <div style={{ color: color }} className={'w-6px h-6px rounded-full shrink-0'}></div>
      <ParagraphWithTooltip weight={fontWeights.medium} size={paragraphSizes.tiny}>
        {text}
      </ParagraphWithTooltip>
    </div>
  );
};
